import apiClient from "./apiClient";
import axios from "axios";

export const loginUser = async (firebaseToken) => {
  return apiClient.post("/auth/login", { firebaseToken });
};

export const GetHostLists = async () => {
  return apiClient.get("/users/other/list?offset=0&limit=10");
};

export const GetMyProfileDetails = async () => {
  return apiClient.get("/users/me");
};

export const GetProfileStories = async () => {
  return apiClient.get("/stories/me");
};

export const GetMyProfilePosts = async () => {
  return apiClient.get("/posts/me");
};

export const UpdateProfileDetails = async (data) => {
  return apiClient.put("/users/update", data);
};

export const GetStorySignedUrl = async () => {
  return apiClient.get("/uploads/signed-url/post");
};

export const CreateStory = async (url) => {
  return apiClient.post("/stories/create", { url });
};

export const GetPostSignedUrl = async () => {
  return apiClient.get("/uploads/signed-url/post");
};

export const uploadFileToSignedUrl = async (signedUrl, file) => {
  return fetch(signedUrl, {
    method: "PUT",
    headers: {
      "content-type": file.type,
    },
    body: file,
  });
};

export const uploadWithProgress = (signedUrl, file, onProgress) => {
  return axios.put(signedUrl, file, {
    headers: {
      "content-type": file.type,
    },
    onUploadProgress: (progressEvent) => {
      if (!progressEvent.total) return;

      const percent = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );

      onProgress(percent);
    },
  });
};

export const DeleteStory = async (storyId) => {
  return apiClient.delete(`/stories/remove/${storyId}`);
};

export const DeletePost = async (postId) => {
  return apiClient.delete(`/posts/remove/${postId}`);
};

export const GetFollowingList = async () => {
  return apiClient.get("/follow/list?offset=0&limit=10");
};

export const GetProfileFollowingList = async () => {
  return apiClient.get("/follow/list/following?offset=0&limit=10");
};

export const GetProfileFollowerList = async () => {
  return apiClient.get("/follow/list/followers?offset=0&limit=10");
};

export const CheckUserFollow = async (userId) => {
  return apiClient.get(`/follow/check/${userId}`);
};

export const FollowUser = async (userId) => {
  return apiClient.post(`/follow/${userId}`);
};

export const UnfollowUser = async (userId) => {
  return apiClient.delete(`follow/${userId}`);
};

export const OtherProfileDetails = async (userId) => {
  return apiClient.get(`/users/other/${userId}`);
};

export const GetOtherProfileStories = async (userId) => {
  return apiClient.get(`/stories/other/${userId}`);
};

export const GetOtherProfilePosts = async (userId) => {
  return apiClient.get(`/posts/other/${userId}`);
};

export const GetBlockReasons = async () => {
  return apiClient.get("/block/reasons");
};

export const BlockUser = async (data) => {
  return apiClient.post("/block", data);
};

export const UnblockUser = async (userId) => {
  return apiClient.delete(`/block/${userId}`);
};

export const GetBlockList = async () => {
  return apiClient.get("/block/users");
};

export const InitiateCall = async (data) => {
  return apiClient.post("/call/initiate", data);
};

export const GetAgoraToken = async (data) => {
  return apiClient.post("/call/agora-token", data);
};

export const GetCallHistory = async (type, page = 1, limit = 10) => {
  return apiClient.get(`/call/history?page=${page}&limit=${limit}&type=${type}`);
};

export const GetHostStatus = async () => {
  return apiClient.get("/host/status");
};

export const GetHostDocumentSignedUrl = async () => {
  return apiClient.get("/uploads/signed-url/host");
};

export const ApplyForHost = async (data) => {
  return apiClient.post("/host/apply", data);
};

export const GetPaymentPacks = async () => {
  return apiClient.get("/payment/packs");
};

export const GetWalletAmount = async () => {
  return apiClient.get("/wallet/status");
};

export const RateThisCall = async (data) => {
  return apiClient.post("/rating/call", data);
};

export const GetNotification = async () => {
  return apiClient.get("/notifications");
};

export const MarkNotification = async (notificationId) => {
  return apiClient.post(`/notifications/mark-read/${notificationId}`);
};

export const GetHostStats = async (period) => {
  return apiClient.get(`/stats/dashboard?period=${period}`);
};

export const LogOut = async () => {
  return apiClient.post("/auth/logout");
};

export const CreateWelcomeMessage = async (data) => {
  return apiClient.post("/chat/auto-replies", data);
};

export const UpdateWelcomeMessage = async (messageId, data) => {
  return apiClient.put(`/chat/auto-replies/${messageId}`, data);
};

export const GetWelcomeMessage = async () => {
  return apiClient.get("/chat/auto-replies");
};

export const GetWelcomeSignedUrl = async (type, count) => {
  return apiClient.get(`/uploads/signed-url/chat/${type}?count=${count}`);
};

export const uploadMultipleFilesToSignedUrls = async (signedUrls, files) => {
  if (signedUrls.length !== files.length) {
    throw new Error("Signed URLs count does not match files count");
  }

  const uploadPromises = signedUrls.map((signedUrl, index) =>
    uploadFileToSignedUrl(signedUrl, files[index])
  );

  return Promise.all(uploadPromises);
};

export const GetChatConversation = async (page = 1, limit = 10) => {
  return apiClient.get(`/chat/conversations?page=${page}&limit=${limit}`);
};

export const GetChatMessage = async (conversationId, params = {}) => {
  return apiClient.get(`/chat/messages/${conversationId}`, { params });
};

export const GetChatMediaSignedUrl = async (type, count) => {
  return apiClient.get(`/uploads/signed-url/chat/${type}?count=${count}`);
};

export const GetOrCreateConversation = async (conversationId) => {
  return apiClient.get(`/chat/conversation/${conversationId}`);
};

export const CreatePayment = async (data) => {
  return apiClient.post("payment/create", data);
};

export const VerifyPayment = async (data) => {
  return apiClient.post("payment/verify", data);
};

export const GetPaymentList = async (page = 1, limit = 20, status = "ALL") => {
  let url = `/payment/list?page=${page}&limit=${limit}`;
  if (status && status !== "ALL") {
    url += `&status=${status.toLowerCase()}`;
  }
  return apiClient.get(url);
};

export const GetWithdrawList = async (page = 1, limit = 20, status = "ALL") => {
  let url = `/withdraw/list?page=${page}&limit=${limit}`;
  if (status && status !== "ALL") {
    url += `&status=${status.toLowerCase()}`;
  }
  return apiClient.get(url);
};

export const CreateWithdraw = async (data) => {
  return apiClient.post("withdraw/create", data);
};

export const SubmitKycBank = async (data) => {
  return apiClient.post("/kyc/bank", data);
};

export const SubmitKycUpi = async (data) => {
  return apiClient.post("/kyc/upi", data);
};

export const GetKycList = async () => {
  return apiClient.get("/kyc/list");
};


